import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Shared} from "../../shared/shared";
import {StudentEntity} from "../../../model/StudentEntity";
import {TutorService} from "../../../service/TutorService";
import {SubscriptionEntity} from "../../../model/SubscriptionEntity";
import {UserService} from "../../../service/UserService";
import {ExamsResultsDto} from "../../../model/ExamsResultsDto";
import {ExamResultSubjectEntity} from "../../../model/ExamResultSubjectEntity";
import {CommonTutorDto} from "../../../dto/CommonTutorDto";
import {timezone} from "../../pipes/timezone.pipe";
import {ExamResultTopicEntity} from "../../../model/ExamResultTopicEntity";
import {TimeStatisticDto} from "../../../dto/TimeStatisticDto";
import {ExamsSubjectResultsDto} from "../../../dto/ExamsSubjectResultsDto";
import {ExamStatisticsDataDto} from "../../../dto/ExamStatisticsDataDto";
import {AnalyticsService} from "../../../service/AnalyticsService";
import {SubjectEntity} from "../../../model/SubjectEntity";
import * as echarts from 'echarts';
import {EChartsOption} from "echarts";
import {SubscriptionStatisticsDto} from "../../../dto/SubscriptionStatisticsDto";
import {TextComponent} from "../generic/table/textComponent/textComponent";
import {CheckboxComponent} from "../generic/table/checkboxComponent/checkboxComponent";
import {TutorFollowupEntity} from "../../../model/TutorFollowupEntity";
import {ExamAnswerDetailDto} from "../../../dto/ExamAnswerDetailDto";
import * as moment from "moment/moment";

@Component({
  selector: 'app-manage-students',
  templateUrl: 'manageStudents.html',
  styleUrls: ['manageStudents.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [timezone]
})
export class ManageStudents {

  students: StudentEntity[];
  studentSubscriptions: SubscriptionEntity[];
  exams: ExamsResultsDto[];
  subjectResults: ExamResultSubjectEntity[];
  topicResults: ExamResultTopicEntity[];
  examAnswerDetail: ExamAnswerDetailDto[];
  tutorFollowups: TutorFollowupEntity[];

  currentStudent: StudentEntity;
  currentSubscription: SubscriptionEntity;
  currentExam: any;
  currentSubject: ExamResultSubjectEntity;
  isSimulationExam = false;
  newTutorFollowup: TutorFollowupEntity;

  commonTutorData: CommonTutorDto;

  timeStatistics: TimeStatisticDto[];
  examsSubjectResults: ExamsSubjectResultsDto[];
  examStatisticsData: ExamStatisticsDataDto;

  statisticsSubjectsSelected: SubjectEntity[] = [];
  statisticsSubjects: SubjectEntity[] = [];

  examSimulations: any;
  examTest: any;
  examFinalExam: any;
  examSubject: any;
  examFailHistory: any;
  examFullHistory: any;
  examHalfHistory: any;

  examsToCompare: any = [];

  showTableStudents = true;
  showTableExams = true;
  showTableSubjectResults = true;
  showTableTopicResults = true;
  showTimeStatistics = false;

  showGraphics = false;
  showGraphics2 = false;
  showCompare = false;
  showContactDate = false;
  showTutorFollowup = false;

  showChangeChartType = true;
  resultsType = false;
  resultsSubjectType = false;
  examType: string
  statisticsSubjectChart = null;

  subscriptionsStatistics: SubscriptionStatisticsDto[];
  subscriptionsStatisticsLibraries: SubscriptionStatisticsDto[];
  subscriptionsStatisticsVideos: SubscriptionStatisticsDto[];

  eResult = 0;
  lPercent = 0;
  vPercent = 0;

  examTypeMenu = "SIMULATION";
  contentTypeMenu = "EXAMS";

  tutorFollowUp: any;

  headersStudents: any = {
    columns: {
      name: {title: 'Name', hide: false, filter: false},
      surname: {title: 'Surname', hide: false, filter: true},
      email: {title: 'Email', hide: false, filter: true},
      mobile: {title: 'Mobile', hide: false, filter: true},
    },
    actions: false,
  }

  headersExams: any = {
    columns: {
      row: {
        title: 'Compare', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => row.examId,
        renderComponent: CheckboxComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCheckbox.subscribe(data => {
              if (data != null) {
                if (this.examsToCompare.find(f => f.examId == data)) {
                  this.examsToCompare = this.examsToCompare.filter(f => f.examId != data);
                } else {
                  this.examsToCompare.push(this.convertObjToTable(this.exams.filter(f => f.exam.id == data))[0]);
                }
              }
            });
          }
        },
      },
      name: {title: 'Name', hide: false, filter: true},
      startDate: {
        title: 'Start date', hide: false, filter: true, type: 'html', valuePrepareFunction: (value) => {
          return this.myTimezone.transform(value, 'dd/MM/yyyy HH:mm');
        }
      },
      endDate: {
        title: 'End date', hide: false, filter: true, type: 'html', valuePrepareFunction: (value) => {
          return this.myTimezone.transform(value, 'dd/MM/yyyy HH:mm');
        }
      },
      success: {title: 'Success', hide: false, filter: true},
      wrong: {title: 'Wrong', hide: false, filter: true},
      white: {title: 'White', hide: false, filter: true},
      doubt: {title: 'Doubt', hide: false, filter: true},
      percentResult: {
        title: '% result', hide: false, filter: true, valuePrepareFunction: (value) => this.roundDisplay(value)
      },
      netResult: {
        title: 'Net result', hide: false, filter: true, valuePrepareFunction: (value) => this.roundDisplay(value)
      },
      percentile: {
        title: 'Percentile', hide: false, filter: true, valuePrepareFunction: (value) => this.roundDisplay(value)
      },
    },
    actions: false,
  }

  headersSubject: any = {
    columns: {
      subjectId: {
        title: 'Name', hide: false, filter: true, type: 'html', valuePrepareFunction: (value) => {
          return this.getSubject(value).name;
        }
      },
      success: {title: 'Success', hide: false, filter: true},
      wrong: {title: 'Wrong', hide: false, filter: true},
      white: {title: 'White', hide: false, filter: true},
      doubt: {title: 'Doubt', hide: false, filter: true},
      percentResult: {
        title: '% result', hide: false, filter: true, valuePrepareFunction: (value) => this.roundDisplay(value)
      },
      netResult: {
        title: 'Net result', hide: false, filter: true, valuePrepareFunction: (value) => this.roundDisplay(value)
      },
    },
    actions: false,
  }

  headersSubjectSimulation: any = {
    columns: {
      subjectId: {
        title: 'Name', hide: false, filter: true, type: 'html', valuePrepareFunction: (value) => {
          return this.getSubject(value).name;
        }
      },
      success: {title: 'Success', hide: false, filter: true},
      wrong: {title: 'Wrong', hide: false, filter: true},
      white: {title: 'White', hide: false, filter: true},
      doubt: {title: 'Doubt', hide: false, filter: true},
      percentResult: {
        title: '% result', hide: false, filter: true, valuePrepareFunction: (value) => this.roundDisplay(value)
      },
      netResult: {
        title: 'Net result', hide: false, filter: true, valuePrepareFunction: (value) => this.roundDisplay(value)
      },
      last5Simulations: {
        title: '% acierto últimos 5 simulacros', hide: false, filter: true,
        valuePrepareFunction: (value) => this.roundDisplay(value)
      },
    },
    actions: false,
  }

  headersTopic: any = {
    columns: {
      topicId: {
        title: 'Name', hide: false, filter: true, type: 'html', valuePrepareFunction: (value) => {
          return this.getTopic(value).name;
        }
      },
      success: {title: 'Success', hide: false, filter: true},
      wrong: {title: 'Wrong', hide: false, filter: true},
      white: {title: 'White', hide: false, filter: true},
      doubt: {title: 'Doubt', hide: false, filter: true},
      percentResult: {
        title: '% result', hide: false, filter: true, valuePrepareFunction: (value) => this.roundDisplay(value)
      },
      netResult: {
        title: 'Net result', hide: false, filter: true, valuePrepareFunction: (value) => this.roundDisplay(value)
      },
    },
    actions: false,
  }

  myColors = ['#8a09f3', '#ed25c8', '#19d9fc', '#7a9672', '#a7cadc', '#d458af', '#b4b308', '#564860', '#22ca4c', '#fae6ff', '#2ec272', '#f97b21', '#8c7c00', '#0f7ba7', '#094eb2', '#849099', '#26d3cd', '#6eb730', '#7ddbdd', '#62557d', '#7b4caa', '#b64849', '#e016dc', '#911947', '#00a48e', '#4ba437', '#9ef9f3', '#4b586f', '#177b46', '#37d5af', '#3bd69e', '#4f0221', '#676103', '#f2be29', '#4b528c', '#fb3945', '#ac963d', '#5f2386', '#9ee6aa', '#029b98', '#1d5822', '#5aa7c5', '#d8cd32', '#469524', '#634f56', '#087aa7', '#e41142', '#c7ed66', '#c8601c', '#20bf54', '#2ba564', '#318fa4', '#16ff51', '#5903ea', '#1d5772', '#2fb4f6', '#976de3', '#dc12d2', '#86bef7', '#61c4e6', '#57de74', '#e40374', '#e6a666', '#759a5a', '#71572a', '#0339bd', '#454b62', '#7e8dcc', '#2d0df5', '#714915', '#3766ac', '#3ed4fa', '#d50cae', '#93499f', '#e7ed3c', '#868c0f', '#72bb2b', '#7c6912', '#c6644e', '#e2b675', '#63fb90', '#ca4535', '#025633', '#4403fd', '#d11af1', '#e22643', '#cfb654', '#ee5e07', '#67c05f', '#9cdaca', '#d96a48', '#72e27a', '#d9e4a0', '#88c0b5', '#7aaefe', '#ebe38a', '#65f97a', '#a3e343', '#cad7d1', '#935bd6'];
  myColors2 = ['#f7cac9', '#92a8d1', '#a6dcef', '#b5e7a0', '#f3d9df', '#ffd966', '#93c5c4', '#d7a9e3', '#b8d8d8', '#f7bd8f'];

  constructor(private shared: Shared, private tutorService: TutorService, private userService: UserService, private myTimezone: timezone, private analyticsService: AnalyticsService) {
  }

  ngOnInit() {
    this.myNgOnInit();
  }

  async myNgOnInit() {
    (await this.tutorService.getCommonTutorData()).subscribe(t => {
      if (t != null) {
        this.commonTutorData = t;
      }
    });

    this.tutorService.getStudents().subscribe(x => {
      if (x != null) {
        this.students = x;
      }
    });
  }

  studentSelected(row: StudentEntity) {
    this.currentStudent = row;

    this.tutorService.getStudentSubscription(this.currentStudent.id).subscribe(x => {
      if (x != null) {
        this.studentSubscriptions = x;
        if (this.studentSubscriptions.length == 1) {
          this.subscriptionSelected(this.studentSubscriptions[0]);
        }
      }
    });
  }

  subscriptionSelected(row: SubscriptionEntity) {
    this.currentSubscription = row;
    this.newTutorFollowup = new TutorFollowupEntity();
    this.newTutorFollowup.notifyStudent = false;
    this.tutorService.getSubscriptionExams(this.currentSubscription.id).subscribe(x => {
      if (x != null) {
        this.exams = x;
        this.examSimulations = this.convertObjToTable(this.exams.filter(f => f.exam.type == 'SIMULATION'));
        this.examTest = this.convertObjToTable(this.exams.filter(f => f.exam.type == 'TESTEXAM'));
        this.examFinalExam = this.convertObjToTable(this.exams.filter(f => f.exam.type == 'FINALEXAM'));
        this.examSubject = this.convertObjToTable(this.exams.filter(f => f.exam.type == 'SUBJECTEXAM'));
        this.examFailHistory = this.convertObjToTable(this.exams.filter(f => f.exam.type == 'FAILEXAM'));
        this.examFullHistory = this.convertObjToTable(this.exams.filter(f => f.exam.type == 'FULLEXAM'));
        this.examHalfHistory = this.convertObjToTable(this.exams.filter(f => f.exam.type == 'HALFEXAM'));
      }
    });

    this.analyticsService.getExamsSubjectResults(this.currentSubscription.reference).subscribe(s => {
      if (s != null) {
        this.examsSubjectResults = s;
      }
    });

    this.tutorService.getTutorFollowup(this.currentSubscription.id).subscribe(s => {
      if (s != null) {
        this.tutorFollowups = s;
      }
    });

    this.getSubscriptionStatistics();
  }

  examSelected(row) {
    this.currentExam = row;
    this.examAnswerDetail = null;
    this.isSimulationExam = this.currentExam.type == 'SIMULATION';
    this.tutorService.getExamSubjectResult(this.currentExam.examId).subscribe(x => {
      if (x != null) {
        this.subjectResults = x;
        if (this.isSimulationExam) {
          this.addLast5SimulationsPercent();
        }
      }
    });

    this.tutorService.getExamAnswerDetail(this.currentExam.examId).subscribe(x => {
      if (x != null) {
        this.examAnswerDetail = x;
      }
    });

    this.analyticsService.getTimeStatistics(this.currentExam.examReference, this.currentSubscription.reference).subscribe(s => {
      if (s != null) {
        this.timeStatistics = s;
        s.forEach(p => {
          if (p.value != 0) this.showTimeStatistics = true
        });
      }
    })

    this.analyticsService.getExamStatisticsData(this.currentExam.examReference).subscribe(s => {
      if (s != null) {
        this.examStatisticsData = s;
      }
    });
  }

  async getExamSubjects() {
    if (this.showCompare) {
      this.examsToCompare.forEach((exam) => {
        this.tutorService.getExamSubjectResult(exam.examId).subscribe(x => {
          if (x != null) {
            exam.subjects = x.sort((a, b) => a.subjectId - b.subjectId);
          }
        });
      });
    }else{
      this.examsToCompare=[];
    }
  }

  saveNewTutorFollowup(){
    if(this.newTutorFollowup.note != null && this.newTutorFollowup.note.length > 10){
      this.newTutorFollowup.tutorId = this.shared.CURRENT_TUTOR.id;
      this.newTutorFollowup.subscriptionId = this.currentSubscription.id;
      this.newTutorFollowup.corpId = this.currentSubscription.corpId;
      this.tutorService.saveTutorFollowup(this.newTutorFollowup).subscribe(x => {
        if (x != null) {
          this.tutorFollowups.push(x);
        }
      });
    }
  }

  subjectSelected(row) {
    this.currentSubject = row;
    this.tutorService.getExamTopicResult(this.currentSubject.subjectId).subscribe(x => {
      if (x != null) {
        this.topicResults = x;
      }
    });
  }

  saveContactDate(event) {
    let value = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
    this.newTutorFollowup.nextContact = moment.tz(value, this.shared.CURRENT_CORP.timezone).tz(this.shared.SERVER_TIMEZONE).format('yyyy-MM-DDTHH:mm:ss');
  }

  convertObjToTable(originalData) {
    return originalData.map(o => ({
      examId: o.exam?.id,
      examReference: o.exam?.reference,
      type: o.exam?.type,
      name: o.exam?.name,
      startDate: o.exam?.startDate,
      endDate: o.exam?.endDate,
      success: o.result?.success,
      wrong: o.result?.wrong,
      white: o.result?.white,
      doubt: o.result?.doubt,
      percentResult: o.result?.percentResult,
      netResult: o.result?.netResult,
      percentile: o.percentile,
    }));
  }

  addLast5SimulationsPercent() {
    if (this.subjectResults == null || this.examsSubjectResults == null) {
      return;
    }

    const currentExamEndDate = new Date(this.currentExam.endDate).getTime();

    const previousSimulations = this.examsSubjectResults
      .filter(f => f.exam.type.toString() == 'SIMULATION' && f.exam.actualExam
        && f.exam.id != this.currentExam.examId && new Date(f.exam.endDate).getTime() < currentExamEndDate)
      .sort((a, b) => new Date(b.exam.endDate).getTime() - new Date(a.exam.endDate).getTime())
      .slice(0, 5);

    this.subjectResults.forEach(sr => {
      const results = previousSimulations
        .map(sim => sim.result.find(p => p.subjectId == sr.subjectId))
        .filter(r => r != null);

      if (results.length > 0) {
        const sum = results.reduce((acc, r) => acc + r.percentResult, 0);
        sr.last5Simulations = this.roundDisplay(sum / results.length);
      } else {
        sr.last5Simulations = null;
      }
    });
  }

  prefilterSubjects() {
    const results = this.examsSubjectResults.filter(f => f.exam.type.toString() == this.examTypeMenu).reduce((acc, curr) => [...acc, ...curr.result], []);
    const subjectsId = results.map(subObjeto => subObjeto.subjectId);
    const uniqueSubjectId = Array.from(new Set(subjectsId));
    this.statisticsSubjects = [];
    this.statisticsSubjectsSelected = [];

    uniqueSubjectId.forEach(y => {
      this.statisticsSubjectsSelected.push(this.commonTutorData.subject.find(m => m.id == y));
      this.statisticsSubjectsSelected = this.statisticsSubjectsSelected.sort((a, b) => {
        if (a.name > b.name) {
          return 1
        } else {
          return -1
        }
      })
      this.statisticsSubjects.push(this.commonTutorData.subject.find(m => m.id == y));
      this.statisticsSubjects = this.statisticsSubjects.sort((a, b) => {
        if (a.name > b.name) {
          return 1
        } else {
          return -1
        }
      })
    })

    let obj = JSON.parse(localStorage.getItem('SUBJECTS_CHART'));
    if (obj != null) {
      this.statisticsSubjectsSelected = obj;
    }
  }


  getSubscriptionStatistics() {
    this.userService.getSubscriptionsStatistics(this.currentSubscription.reference).subscribe(x => {
      if (x != null) {
        this.subscriptionsStatistics = x;
        this.subscriptionsStatisticsLibraries = this.subscriptionsStatistics.filter(x => x.type == 'LIBRARY_FOLDER');
        this.subscriptionsStatisticsVideos = this.subscriptionsStatistics.filter(x => x.type == 'VIDEO_FOLDER');

        this.statistics();
      }
    });
  }

  check() {
    console.log(this.subscriptionsStatisticsVideos);
    console.log(this.subscriptionsStatisticsLibraries);
  }

  async prepareExamsChart() {
    await this.delay(200);
    var chartDom = document.getElementById('examsChart')!;
    var myChart = echarts.init(chartDom);
    var option: EChartsOption;
    let resultType = 'Netas';

    let objs = this.exams.filter(f => f.exam.type == this.examTypeMenu).map(e => {
      if (e.exam.actualExam) return e.exam.name
    });
    let res = this.exams.filter(f => f.exam.type == this.examTypeMenu).map(e => {
      if (e.exam.actualExam) {
        if (!this.resultsType) {
          return this.roundNumber(e.result.netResult)
        } else {
          resultType = '%';
          return this.roundNumber(e.result.percentResult)
        }
      }
    });
    let percentile = this.exams.filter(f => f.exam.type == this.examType).map(e => {
      if (e.exam.actualExam) {
        return this.roundNumber(e.percentile)
      }
    });

    option = {
      tooltip: {
        trigger: 'axis',
        formatter: '{b}<br />{c} ' + resultType + '<br />Percentil {c1}'
      },
      dataZoom: [
        {
          show: true,
          start: 0,
          end: 100
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        },
      ],
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: objs,
        splitLine: {show: false},
        axisLabel: {
          interval: 0,
          rotate: 15
        },
      },
      yAxis: [{
        name: resultType,
        type: 'value'
      }, {
        name: 'Percentil',
        type: 'value'
      }],
      series: [
        {
          data: res,
          type: 'line',
          smooth: true,
          markPoint: {
            data: [
              {type: 'max', name: 'Max'},
              {type: 'min', name: 'Min'}
            ]
          },
          markLine: {
            data: [{type: 'average', name: 'Avg'}]
          }
        },
        {
          data: percentile,
          type: 'line',
          smooth: true,
          yAxisIndex: 1,
          markPoint: {
            data: [
              {type: 'max', name: 'Max'},
              {type: 'min', name: 'Min'}
            ]
          },
        }
      ]
    };

    option && myChart.setOption(option, true);
  }


  async prepareExamsSubjectChart() {
    await this.delay(200);
    this.prefilterSubjects();
    await this.delay(200);
    var chartDom = document.getElementById('examsSubjectChart')!;
    this.statisticsSubjectChart = echarts.init(chartDom);
    var option: EChartsOption;

    let objs = this.examsSubjectResults.filter(f => f.exam.type.toString() == this.examTypeMenu).map(e => {
      if (e.exam.actualExam) return e.exam.name
    });
    let resObjs = this.getResObjs();

    option = {
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      dataZoom: [
        {
          show: true,
          start: 0,
          end: 100
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        },
      ],
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: objs,
        splitLine: {show: false},
        axisLabel: {
          interval: 0,
          rotate: 15
        },
      },
      yAxis: {
        type: 'value'
      },
      series: resObjs
    };

    option && this.statisticsSubjectChart.setOption(option, true);
  }

  getResObjs() {
    let resObjs = [];

    this.statisticsSubjectsSelected.forEach(s => {
      let res = this.examsSubjectResults.filter(f => f.exam.type.toString() == this.examTypeMenu).map(e => {
        let r = e.result.find(p => p.subjectId == s.id);
        if (r != null) {
          if (!this.resultsSubjectType) {
            return this.roundNumber(r.netResult);
          } else {
            return this.roundNumber(r.percentResult);
          }
        } else {
          return 0;
        }
      });
      resObjs.push({data: res, type: 'line', smooth: true, name: s.name});
    });

    resObjs = resObjs.sort((a, b) => {
      if (a.name > b.name) {
        return 1
      } else {
        return -1
      }
    })
    return resObjs;
  }

  getAnswerStatusClass(status) {
    if (status == 'SUCCESS') {
      return 'answerSuccess';
    } else if (status == 'WRONG') {
      return 'answerWrong';
    } else {
      return 'answerWhite';
    }
  }

  checkNumber(num) {
    if (num == null) {
      return '0';
    }
    return num;
  }

  async prepareTimeChart() {
    await this.delay(200);
    var chartDom = document.getElementById('timeChart') as HTMLDivElement;
    var myChart = echarts.init(chartDom);
    let names = this.timeStatistics.map(x => x.questionNum);
    let successValue: number[] = [];
    let values: number[] = [];
    let wrongValue: number[] = [];
    var defaultPalette = ['#90EE90', '#87CEEB', '#FF6347'];
    let secs = this.shared.t('tabs.exams.seconds');
    this.timeStatistics.forEach(x => {
      if (x.estimatedValue < x.value) {
        successValue.push(0);
        values.push(x.value);
        wrongValue.push(x.estimatedValue);
      } else {
        successValue.push(x.value);
        values.push((x.estimatedValue - x.value));
        wrongValue.push(0);
      }
    });

    let option = {
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          if (params[0].value == 0) {
            let t = params[1].value + params[2].value;
            if (t == params[1].value) {
              return `Pregunta #${params[0].axisValueLabel}<br />Tiempo estimado: ${params[1].value} ${secs}<br />Tiempo usado: ${params[2].value} ${secs}`;
            } else {
              return `Pregunta #${params[0].axisValueLabel}<br />Tiempo estimado: ${params[1].value} ${secs}<br />Tiempo usado: ${t} ${secs}`;
            }
          } else if (params[2].value == 0) {
            return `Pregunta #${params[0].axisValueLabel}<br />Tiempo estimado: ${params[1].value} ${secs}<br />Tiempo usado: ${params[0].value} ${secs}`;
          }
        },
        axisPointer: {
          type: 'shadow',
          label: {
            show: true
          }
        }
      },
      color: defaultPalette,
      toolbox: {
        show: false,
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: false},
          magicType: {show: true, type: ['line', 'bar']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      calculable: true,
      legend: {
        data: ['Growth'],
        itemGap: 5
      },
      xAxis: [
        {
          type: 'category',
          data: names
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Segundos por pregunta',
          axisLabel: {
            formatter: function (a: number) {
              a = +a;
              return isFinite(a) ? echarts.format.addCommas(+a) : '';
            }
          }
        }
      ],
      dataZoom: [
        {
          show: true,
          start: 0,
          end: 100
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        },
      ],
      series: [
        {
          name: 'Antes',
          type: 'bar',
          stack: 'Ad',
          data: successValue
        },
        {
          name: 'Segundos por pregunta',
          type: 'bar',
          stack: 'Ad',
          data: values
        },
        {
          name: 'Pasados',
          type: 'bar',
          stack: 'Ad',
          data: wrongValue
        }
      ]
    };

    myChart.setOption(option, true);
  }

  statistics() {
    let r1 = 0;
    let r2 = 0;

    let s = 0;
    this.subscriptionsStatisticsVideos.map((x1, index) => {
      if (x1.list != null && x1.list.length > 0) {
        let s1 = 0;
        x1.list.forEach(x2 => {
          if (x2.list != null && x2.list.length > 0) {
            let s2 = 0;
            x2.list.forEach(x3 => {

              if (x3.list != null && x3.list.length > 0) {
                let s3 = 0;
                x3.list.forEach(x4 => {

                  if (x4.list != null && x4.list.length > 0) {
                    let s4 = 0;
                    x4.list.forEach(x5 => {
                      s4 = s4 + x5.percentajeResult;
                    });
                    x4.percentajeResult = Math.round(s4 / x4.list.length);
                  } else {
                    if (x4.percentajeResult == null) {
                      x4.percentajeResult = 0;
                    }
                  }
                  s3 = s3 + x4.percentajeResult;

                });
                x3.percentajeResult = Math.round(s3 / x3.list.length);
              } else {
                if (x3.percentajeResult == null) {
                  x3.percentajeResult = 0;
                }
              }
              s2 = s2 + x3.percentajeResult;

            });
            x2.percentajeResult = Math.round(s2 / x2.list.length);
          } else {
            if (x2.percentajeResult == null) {
              x2.percentajeResult = 0;
            }
          }
          s1 = s1 + x2.percentajeResult;
        });
        x1.percentajeResult = Math.round(s1 / x1.list.length);
      } else {
        if (x1.percentajeResult == null) {
          x1.percentajeResult = 0;
        }
      }
      s = s + x1.percentajeResult;
    });
    this.vPercent = Math.round(s / this.subscriptionsStatisticsVideos.length);


    let p = 0;
    this.subscriptionsStatisticsLibraries.map(x1 => {
      if (x1.list != null && x1.list.length > 0) {
        let s1 = 0;
        x1.list.forEach(x2 => {
          if (x2.list != null && x2.list.length > 0) {
            let s2 = 0;
            x2.list.forEach(x3 => {

              if (x3.list != null && x3.list.length > 0) {
                let s3 = 0;
                x3.list.forEach(x4 => {

                  if (x4.list != null && x4.list.length > 0) {
                    let s4 = 0;
                    x4.list.forEach(x5 => {
                      s4 = s4 + x5.percentajeResult;
                    });
                    x4.percentajeResult = Math.round(s4 / x4.list.length);
                  } else {
                    if (x4.percentajeResult == null) {
                      x4.percentajeResult = 0;
                    }
                  }
                  s3 = s3 + x4.percentajeResult;

                });
                x3.percentajeResult = Math.round(s3 / x3.list.length);
              } else {
                if (x3.percentajeResult == null) {
                  x3.percentajeResult = 0;
                }
              }
              s2 = s2 + x3.percentajeResult;

            });
            x2.percentajeResult = Math.round(s2 / x2.list.length);
          } else {
            if (x2.percentajeResult == null) {
              x2.percentajeResult = 0;
            }
          }
          s1 = s1 + x2.percentajeResult;
        });
        x1.percentajeResult = Math.round(s1 / x1.list.length);
      } else {
        if (x1.percentajeResult == null) {
          x1.percentajeResult = 0;
        }
      }
      p = p + x1.percentajeResult;
    });
    this.lPercent = Math.round(p / this.subscriptionsStatisticsLibraries.length);
  }

  checkSubject(id) {
    let t = this.statisticsSubjectsSelected.find(r => r.id == id);
    if (t == null) {
      this.statisticsSubjectsSelected.push(this.commonTutorData.subject.find(x => x.id == id));
    } else {
      this.statisticsSubjectsSelected = this.statisticsSubjectsSelected.filter(r => r.id != id);
    }

    localStorage.setItem('SUBJECTS_CHART', JSON.stringify(this.statisticsSubjectsSelected));

    this.prepareExamsSubjectChart();
  }

  isSubjectChecked(id) {
    if (this.statisticsSubjectsSelected.find(r => r.id == id)) {
      return true;
    } else {
      return false;
    }
  }


  roundNumber(num) {
    return num.toFixed(2);
  }

  roundDisplay(num) {
    if (num == null) {
      return num;
    }
    return Math.round(num * 100) / 100;
  }

  getTutor(id) {
    let tutor = this.commonTutorData.tutor.find(c => c.id == id);
    return tutor.name +' '+ tutor.surname;
  }

  getSubject(id) {
    return this.commonTutorData.subject.find(c => c.id == id);
  }

  getTopic(id) {
    return this.commonTutorData.topic.find(c => c.id == id);
  }

  getCourse(id) {
    return this.commonTutorData.course.find(c => c.id == id);
  }

  getCourseType(id) {
    return this.commonTutorData.courseType.find(c => c.id == id);
  }

  getModality(id) {
    return this.commonTutorData.modality.find(c => c.id == id);
  }

  getSite(id) {
    return this.commonTutorData.site.find(c => c.id == id);
  }

  getTurn(id) {
    return this.commonTutorData.turn.find(c => c.id == id);
  }


  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
